import { createPortal } from 'react-dom';
import { MemberIcon } from './MemberUI';

function BottomNavigation({ active, onMonitor, onMatches, onScan, onReward, onProfile, scanLabel = 'สแกน' }) {
  const items = [
    { key: 'monitor', icon: 'court', label: 'ดูคิวสนาม', onClick: onMonitor },
    { key: 'matches', icon: 'users', label: 'รีเควสคู่', onClick: onMatches },
    { key: 'scan', icon: 'scan', label: scanLabel, onClick: onScan },
    { key: 'reward', icon: 'gift', label: 'รางวัล', onClick: onReward },
    { key: 'profile', icon: 'profile', label: 'ประวัติ', onClick: onProfile }
  ];
  return createPortal(<nav className="app-bottom-nav nm-bottom-nav" aria-label="เมนูด้านล่าง">{items.map(item => <button key={item.key} type="button" className={`${active === item.key ? 'is-active' : ''} ${item.key === 'scan' ? 'nm-scan-action' : ''}`} aria-current={active === item.key ? 'page' : undefined} aria-label={item.key === 'scan' ? 'สแกน QR' : item.label} onClick={item.onClick}><span><MemberIcon name={item.icon} size={25} /></span><small>{item.label}</small></button>)}</nav>, document.body);
}
export default BottomNavigation;
